import React, { createContext, useContext, useState } from 'react';
import { getItemsByGenre } from '../api/itemsApi';
import { normalizeProgram } from '../models/Program';

const ItemsContext = createContext(null);

export const ItemsProvider = ({ children }) => {
  const [itemsByGenre, setItemsByGenre] = useState({});
  const [loadingByGenre, setLoadingByGenre] = useState({});
  const [errorByGenre, setErrorByGenre] = useState({});

  const loadItems = async (genre) => {
    if (!genre) return;
    if (itemsByGenre[genre]) return;
    setLoadingByGenre((s) => ({ ...s, [genre]: true }));
    setErrorByGenre((s) => ({ ...s, [genre]: null }));
    try {
      const data = await getItemsByGenre(genre);
      // normalize items into Program model and filter by genre
      const normalized = Array.isArray(data)
        ? data.map(normalizeProgram).filter(p => String(p.genre) === String(genre))
        : [];
      setItemsByGenre((s) => ({ ...s, [genre]: normalized }));
    } catch (err) {
      setErrorByGenre((s) => ({ ...s, [genre]: err.message || String(err) }));
    } finally {
      setLoadingByGenre((s) => ({ ...s, [genre]: false }));
    }
  };

  const refreshItems = async (genre) => {
    setItemsByGenre((s) => ({ ...s, [genre]: undefined }));
    return loadItems(genre);
  };

  const getItemById = (id) => {
    if (!id) return null;
    // Search through all genres for the item
    for (const genre in itemsByGenre) {
      const items = itemsByGenre[genre];
      if (Array.isArray(items)) {
        const item = items.find(item => String(item.id) === String(id));
        if (item) return item;
      }
    }
    return null;
  };

  return (
    <ItemsContext.Provider value={{ itemsByGenre, loadItems, refreshItems, getItemById, loadingByGenre, errorByGenre }}>
      {children}
    </ItemsContext.Provider>
  );
};

export const useItems = () => {
  const ctx = useContext(ItemsContext);
  if (!ctx) throw new Error('useItems must be used within ItemsProvider');
  return ctx;
};

export default ItemsContext;
